import FIELD_VALIDATION_CAPTIONS from './FIELD_VALIDATION_CAPTIONS'

export const AddressFinderCaptionsList = {
  'No matching address results found': 'No results. Try a different search',
  Searching: 'Searching...',
  'Address Finder Api Error': 'Can’t fetch results. Please retry',
  ...FIELD_VALIDATION_CAPTIONS,
}

export const ExternalLookupCaptionsList = AddressFinderCaptionsList

export const ARIA_CAPTIONS = {
  readonly: 'readonly',
  mandatory: 'mandatory',
  disabled: 'disabled',
  Search: 'Search',
  TextCounter: 'Quantity Counter',
  text: 'Text',
  addressFinder: 'Address Finder',
  externalLookup: 'External Lookup',
  textarea: 'TextArea',
  richtextarea: 'Rich TextArea',
  email: 'Email',
  number: 'Number',
  phone: 'Phone',
  currency: 'Currency',
  slider: 'Slider',
  url: 'URL',
  date: 'Date',
  time: 'Time',
  datetime: 'DateTime',
  checkbox: 'Checkbox',
  switch: 'Switch',
  radio: 'Radio',
  select: 'Select',
  multiSelect: 'Multi Select',
  buttongroup: 'ButtonGroup',
  lookup: 'Lookup',
  fileupload: 'File Upload',
  signature: 'Signature',
}

export default {
  // 'Max file size': 'Max File Upload Size is 30MB',
  'This project is disabled': 'This project is disabled',
  'Ask Project owner about this': `Ask Project's owner about this`,
  'Validation Button Label': `OK`,
  'No matching address results found': 'No matching address results found',
  Searching: 'Searching...',
  ...AddressFinderCaptionsList,
  Close: 'Close',
  'Turn on the notifications': 'Turn on the notifications',
  Cancel: 'Cancel',
  Allow: 'Allow',
  // ...ARIA_CAPTIONS
}
